import './styles.css';
import Phaser from 'phaser';
import { gameConfig } from './game/config';

const root = document.querySelector<HTMLElement>('#game-root');
if (!root) throw new Error('Missing #game-root');
root.innerHTML = `
  <div id="app-shell" data-layout="full">
    <div id="game-stage">
      <div id="game-canvas"></div>
      <div id="game-ui"></div>
    </div>
    <aside id="game-hud" aria-label="ゲーム情報"></aside>
    <nav id="mobile-controls" aria-label="タッチ操作"></nav>
  </div>`;

new Phaser.Game(gameConfig);
